export class Broadcast {
  public channel_name = '';
  public message = '';
}
